import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    TrainingSessionStudent,
    Student,
    RegistrationDetailService,
} from '../../../../../../../../_services';
import { Observable } from 'rxjs';
import Timer = NodeJS.Timer;

@Component({
    selector: 'registration-student-edition',
    templateUrl: 'student-edition.component.html',
    styleUrls: [
        '../../../../registration.component.scss',
        '../../../../../../../_shared/label/label.component.scss',
    ],
})
export class SessionStudentEditionComponent implements OnInit {
    @Output() getNewStudent: EventEmitter<any> = new EventEmitter<any>();
    @Input() tsStudent: TrainingSessionStudent;
    @Input() tsStudents: TrainingSessionStudent[];
    @Input() saving: boolean;

    timeout: Timer;
    students = (email: any): Observable<any[]> => {
        if (this.timeout) {
            clearTimeout(this.timeout);
            // TODO: use timeout
        } else if (email) {
            return this.findStudents(email);
        }
    };

    constructor(private registrationDetailService: RegistrationDetailService) {}

    ngOnInit(): void {}

    save(student: TrainingSessionStudent) {
        this.getNewStudent.emit(student);
    }

    cancel(student: TrainingSessionStudent) {
        this.getNewStudent.emit(null);
        student.editingMode = 'noEdition';
    }

    isDisabled() {
        if (this.saving) {
            return false;
        }
        if (
            this.tsStudent.email == '' ||
            this.tsStudent.firstName == '' ||
            this.tsStudent.lastName == ''
        ) {
            return true;
        }

        if (!this.isEmailValid(this.tsStudent.email)) {
            return true;
        }
        return false;
    }

    isEmailValid(email) {
        const re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    search(email: string): void {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        // this.timeout = setTimeout(_ => {
        //     if (email.length >= 3) {
        //         this.findStudents(email);
        //     }
        // }, 1000);
    }

    findStudents(email): Observable<any[]> {
        return this.registrationDetailService.findStudentsByPartialEmail(email);
    }

    studentListFormatter(data: Student): string {
        let html = '';
        html += data.email ? `<span><strong>${data.email}</strong></span>` : '';
        html += data.firstName
            ? `<span><small> - ${data.firstName}</small></span>`
            : '';
        html += data.lastName
            ? `<span><small> ${data.lastName}</small></span>`
            : '';
        return html;
    }

    changeStudent(newVal) {
        if (
            newVal !== null &&
            typeof newVal !== 'undefined' &&
            newVal.id !== null &&
            typeof newVal.id !== 'undefined'
        ) {
            this.tsStudent.email = newVal.email;
            this.tsStudent.firstName = newVal.firstName;
            this.tsStudent.lastName = newVal.lastName;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/registration-contact/registration-student/student-edition/student-edition.component.ts